import { p } from '@/plugins/permission'

export default {
  check: {
    permission: [p.schoolManage]
  }
}
